/**
 * Словарь культур канона в форме прототипа — одно место на все адаптеры.
 *
 * Культуры приходят с разных ответов (циклы района, размещения на карте,
 * реестр), и каждый адаптер, собравший «свои» культуры, давал бы экрану
 * неполный словарь: карта красила бы по культурам, которых в словаре нет, как
 * «размещение неизвестно». Поэтому набор культур — весь словарь канона, а
 * имена из ответа сервера, где он их назвал, имеют приоритет.
 */

import { CROP_ORDER, cropName } from '../../../lib/crops';
import type { Crop } from '../../data/types';

/** Токены цвета прототипа для канонических кодов культур. */
const CROP_COLOR: Record<string, string> = {
  COTTON: 'crop-cotton',
  GRAIN: 'crop-wheat',
  POTATO: 'crop-potato',
  RICE: 'crop-other',
  FODDER: 'crop-feed',
  MELON: 'crop-other',
  LEGUMES: 'crop-other',
  OTHER_CROPS: 'crop-other',
};

/** Весь словарь культур канона; `named` — имена, которые назвал ответ сервера. */
export function canonCrops(named: ReadonlyMap<string, string> = new Map()): Crop[] {
  // Сначала — культуры, которые назвал ответ (его порядок и его имена), затем
  // остальной словарь канона.
  const codes = [...named.keys(), ...CROP_ORDER.filter((code) => !named.has(code))];
  return codes.map((code) => ({
    id: code,
    name: cropName(code, named.get(code)),
    color: CROP_COLOR[code.toUpperCase()] ?? `crop-${code.toLowerCase()}`,
  }));
}
